import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function FAQ() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Container
        id="faq"
        sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            marginTop: 8
        }}
    >
        <Typography
            variant="h5" 
            sx={{ 
                fontFamily: 'Fredoka One, sans-serif', 
                color: 'grey.800', 
                marginBottom: '20px',
            }}
        >
            Frequently Asked Questions
        </Typography>

        <Box sx={{ width: '100%' }}>
            <Accordion
                expanded={expanded === 'panel1'}
                onChange={handleChange('panel1')}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1d-content"
                    id="panel1d-header"
                >
                    <Typography fontFamily="Poppins, sans-serif" variant="body2">
                        When will my article be published?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography
                        variant="body2"
                        gutterBottom
                        fontFamily="Roboto, sans-serif"
                        sx={{ maxWidth: { sm: '100%', md: '70%' } }}
                    >
                        Manuscripts are published on the website after completing the peer review process and incorporating the author's feedback.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion
                expanded={expanded === 'panel2'}
                onChange={handleChange('panel2')}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2d-content"
                    id="panel2d-header"
                >
                    <Typography  fontFamily="Poppins, sans-serif" variant="body2">
                        What benefits do I receive as a peer reviewer for the Journal of the West African Journal of Life Sciences?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography
                        variant="body2"
                        gutterBottom
                        fontFamily="Roboto, sans-serif"
                        sx={{ maxWidth: { sm: '100%', md: '70%' } }}
                    >
                        If you review 10 manuscripts and submit valuable reports, you will be eligible to publish one article for free with the West African Journal of Life Sciences.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion
                expanded={expanded === 'panel3'}
                onChange={handleChange('panel3')}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3d-content"
                    id="panel3d-header"
                >
                    <Typography fontFamily="Poppins, sans-serif" variant="body2">
                        How long does it take to get feedback from reviewers? 
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography
                        variant="body2"
                        gutterBottom
                        fontFamily="Roboto, sans-serif"
                        sx={{ maxWidth: { sm: '100%', md: '70%' } }}
                    >
                        14 days to return their completed review reports and the reviewed manuscript.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion
                expanded={expanded === 'panel4'}
                onChange={handleChange('panel4')}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4d-content"
                    id="panel4d-header"
                >
                    <Typography fontFamily="Poppins, sans-serif" variant="body2">
                        Is there a specific timeframe to respond to reviewer feedback, as an author? 
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography
                        variant="body2"
                        gutterBottom
                        fontFamily="Roboto, sans-serif"
                        sx={{ maxWidth: { sm: '100%', md: '70%' } }}
                    >
                        Yes, authors are required to respond to reviewer feedback within 7 days of receiving the notification.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion
                expanded={expanded === 'panel5'}
                onChange={handleChange('panel5')}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel5d-content"
                    id="panel5d-header"
                >
                    <Typography fontFamily="Poppins, sans-serif" variant="body2">
                        When can I submit my manuscript, as an author?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography
                        variant="body2"
                        gutterBottom
                        fontFamily="Roboto, sans-serif"
                        sx={{ maxWidth: { sm: '100%', md: '70%' } }}
                    >
                        Manuscripts can be submitted at any time once they are ready.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion
                expanded={expanded === 'panel6'}
                onChange={handleChange('panel6')}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel6d-content"
                    id="panel6d-header"
                >
                    <Typography fontFamily="Poppins, sans-serif" variant="body2">
                        What types of manuscripts are accepted by the West African Journal of Life Sciences?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography
                        variant="body2"
                        gutterBottom
                        fontFamily="Roboto, sans-serif"
                        sx={{ maxWidth: { sm: '100%', md: '70%' } }}
                    >
                        The journal publishes research manuscripts, short communications, technical reports, review articles, and case studies.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion
                expanded={expanded === 'panel7'}
                onChange={handleChange('panel7')}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel7d-content"
                    id="panel7d-header"
                >
                    <Typography fontFamily="Poppins, sans-serif" variant="body2">
                        How can i know the status of my manuscript submisson or form applications?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography
                        variant="body2"
                        gutterBottom
                        fontFamily="Roboto, sans-serif"
                        sx={{ maxWidth: { sm: '100%', md: '70%' } }}
                    >
                        We will always update you via the provided email at different stages, additionally for manuscript submissons, you can track
                        the status through the authors dashboard.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </Box>

    </Container>
  );
}
export default FAQ;